module.exports = __webpack_public_path__ + "img/onlineCatalog.2a07b725.svg";